// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__NI3IX","wrapper":"PriceList_wrapper__wXKHF","footerStyle":"PriceList_footerStyle__Rq886"};